import { toolkitUrls } from '@/links'

export async function getSubjectsDomainsGrades() {
  const url = `${toolkitUrls.api}/subjects?refetch=1`
  const response = await fetch(url, { credentials: 'include' })
  if (!response.ok) throw new Error(`${response.status} status response from HTTP request`)
  const data = await response.json()

  const subjects = []
  const subjectDomainsMap = {}
  const subjectGradesMap = {}

  data.forEach(subjData => {
    const subject = Object.keys(subjData).filter(key => key !== 'grades')[0]
    subjects.push(subject)
    subjectDomainsMap[subject] = subjData[subject]
    subjectGradesMap[subject] = subjData.grades
  })

  return {
    subjects,
    subjectDomainsMap,
    subjectGradesMap
  }
}
